import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class BootstrapService {

    /**
     * Whether the bootstrap sequence was executed or not
     *
     * @type {boolean}
     */
    public booted = false;

    /**
     * Subject that returns the current bootstrapping state
     *
     * @type {BehaviorSubject<boolean>}
     */
    public ready: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    /**
     * All operations to execute before routing
     *
     * @type {Array}
     */
    protected runSequence = [];

    /**
     * All operations to execute before routing and before the normal sequence
     * -> e.g. Remove cached entities, settings etc.
     *
     * @type {Array}
     */
    protected runPreBootstrapSequence = [];

    /**
     * Add a process to the run sequence
     *
     * @param callback
     */
    public addToSequence(callback, preBootstrap = false) {

        if (!preBootstrap) {
            this.runSequence.push(callback);
        } else {
            this.runPreBootstrapSequence.push(callback);
        }
    }

    /**
     * Boot the application by executing all processes in the runSequence
     *
     * @returns {Observable}
     */
    public boot() {
        let executions = 0;

        return new Observable(observer => {

            this.preBoot().subscribe(ready => {

                if (this.runSequence.length) {
                    this.runSequence.forEach(process => {
                        process().subscribe(() => {
                            executions++;

                            if (executions === this.runSequence.length) {
                                observer.next(true);
                                this.ready.next(true);

                                this.booted = true;
                            }
                        });
                    });
                } else {
                    // nothing to do -> bootstrap completed
                    observer.next(true);
                    this.booted = true;
                }

            });

        });
    }

    protected preBoot() {

        let executions = 0;

        console.log('Pre boot!!');

        return new Observable(observer => {

            if (this.runPreBootstrapSequence.length) {
                this.runPreBootstrapSequence.forEach(process => {
                    process().subscribe(() => {
                        executions++;

                        if (executions === this.runPreBootstrapSequence.length) {
                            observer.next(true);
                            this.ready.next(true);

                            this.booted = true;
                        }
                    });
                });
            } else {
                // nothing to do -> bootstrap completed
                observer.next(true);
                this.booted = true;
            }
        });

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/bootstrap/bootstrap.service.ts